// extracted by mini-css-extract-plugin
export default {"title":"Title_title__AnPct","activeTitle":"Title_activeTitle__T8Abe","amountInTitle":"Title_amountInTitle__-QdEz"};